import ENDPOINTS from 'shared/api/endpoints';
import RequestClient from 'shared/api/http-client';

export type MarketTypeGroup = {
  sport_id: number | string;
  market_type_group_id: number | string;
  [k: string]: unknown;
};

export async function fetchMarketTypeGroups(): Promise<MarketTypeGroup[]> {
  const res = await RequestClient.get(ENDPOINTS.MARKET_TYPES_LISTS);
  const data = res.data;
  return Array.isArray(data) ? (data as MarketTypeGroup[]) : [];
}

